import { createRouter, createWebHashHistory } from "vue-router";
import TopPage from '../views/TopPage.vue';
import SearchCourse from '../views/SearchCourse.vue';
import UpdateHistory from '../views/UpdateHistory.vue';

const router = createRouter({
  history: createWebHashHistory(''),
  routes: [
    {
      path: '/',
      name: 'TopPage',
      component: TopPage,
    },
    {
      path: '/search',
      name: 'SearchCourse',
      component: SearchCourse,
    },
    {
      path: '/update',
      name: 'UpdateHistory',
      component: UpdateHistory,
    },
  ]
});

export default router;
